import React from 'react';
import {
  columnDescription,
  columnName,
  columnSelect,
} from '@/constants/fields';
import NameDescriptionColumns from '@/components/table/NameDescriptionColumns';

const DictionariesTableColumns = ({
  columns = [
    columnSelect,
    columnName,
    columnDescription],
}) => (
  <NameDescriptionColumns columns={columns} />
);

export default DictionariesTableColumns;
